import { render, staticRenderFns } from "./InventoryViewReport.vue?vue&type=template&id=4d67dde0&"
import script from "./InventoryViewReport.vue?vue&type=script&lang=ts&"
export * from "./InventoryViewReport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports